'use client';

import React, { memo, RefObject, useState } from 'react';
import { LoadingSpinner } from '@crabs-ai/ds-react';
import { MediaContentAdapterProps } from '../types';

// rendering-hoist-jsx: 정적 className 호이스팅
const videoClassName = 'max-h-full max-w-full object-contain';
const spinnerContainerClassName =
  'absolute inset-0 flex items-center justify-center';

/**
 * 비디오 미디어 어댑터
 * - <video> + 로딩 스피너
 * - rerender-memo: memo로 감싸 불필요 리렌더 차단
 * - rendering-conditional-render: 삼항 연산자 사용
 */
export const VideoContent = memo(function VideoContent({
  url,
  mediaRef,
  onLoaded,
}: MediaContentAdapterProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {!isLoaded ? (
        <div className={spinnerContainerClassName}>
          <LoadingSpinner
            size="large"
            className="fill-sys-cont-inverse-light"
          />
        </div>
      ) : null}
      <video
        ref={mediaRef as RefObject<HTMLVideoElement>}
        src={url}
        className={videoClassName}
        playsInline
        preload="auto"
        onLoadedMetadata={() => {
          onLoaded();
          setIsLoaded(true);
        }}
      />
    </>
  );
});
